'use client';

import {
  getUnreadMode,
  getUnreadTotal,
  subscribeUnread,
  subscribeUnreadMode,
} from '@/app/lib/unread/unread-store';
import { useSyncExternalStore } from 'react';

export function useUnreadCount({ enabled = true }: { enabled?: boolean } = {}) {
  const count = useSyncExternalStore(subscribeUnread, getUnreadTotal, () => 0);
  const mode = useSyncExternalStore(subscribeUnreadMode, getUnreadMode, () => 'off');

  return {
    count: enabled ? count : 0,
    mode: enabled ? mode : 'off',
  };
}
